import { PatientDetailScope } from 'mormaii-web-presentation/patient-detail'
import type { ViewFactory } from 'wdc-cube-solid'

import { PatientDetailView } from './v-patient-detail'

export function registerViews(rv: typeof ViewFactory.register) {
    rv(PatientDetailScope, PatientDetailView)
}

export { PatientDetailView }
